<div class="contract-overview-page">
    <app-date-navigation [dateNavigationOptions]="dateNavigationOptions" (selectedDateUpdated)="updateSelectedDate()"></app-date-navigation>

    <div *ngIf="loading" class="m-t-2">
        <app-loading-message></app-loading-message>
    </div>

    <ng-container *ngIf="!loading">
        <div *ngIf="!report || !report.divisions || report.divisions.length === 0" class="m-t-2 text-muted">Geen contractgegevens beschikbaar.</div>

        <div class="division-card" *ngFor="let division of report?.divisions">
            <div class="division-header">
                <h3>{{ division.divisionLabel }}</h3>
            </div>

            <div class="months-grid">
                <div class="month-card" *ngFor="let month of division.months">
                    <div class="month-header">
                        <strong>{{ getMonthLabel(month.month) }}</strong>
                        <span class="text-muted">{{ month.contracts.length }} contract(en)</span>
                    </div>

                    <div *ngIf="month.contracts.length === 0" class="text-muted small">Geen contracten actief.</div>

                    <ul *ngIf="month.contracts.length > 0" class="contract-list">
                        <li *ngFor="let contract of month.contracts">
                            <div class="contract-project">{{ contract.projectTitle }}</div>
                            <div class="contract-meta">
                                {{ contract.contractSource === 'PROJECT_ACCOUNTS' ? 'Project account' : 'Contract' }} - {{ contract.contractLabel }}
                            </div>
                            <div class="contract-period text-muted small">
                                {{ contract.effectiveFrom || '-' }} → {{ contract.effectiveTo || 'open einde' }}
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="missing-contracts m-t-2">
                <h4>Projecten zonder contract</h4>
                <div class="text-muted small" *ngIf="division.projectsWithoutContracts.length === 0">Alle projecten hebben minstens één contract.</div>
                <ul *ngIf="division.projectsWithoutContracts.length > 0" class="missing-list">
                    <li *ngFor="let project of division.projectsWithoutContracts">{{ project.projectTitle }}</li>
                </ul>
            </div>
        </div>
    </ng-container>
</div>
